module.exports = __webpack_public_path__ + "static/media/post-img5.6729b007.jpg";